import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../SectionTitle/SectionTitle';

import Shape from '../../images/s-shape.png';
import Shape1 from '../../images/arrow.svg';

const SubscribeSection = () => {
    const { t } = useTranslation();
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});

    const validate = () => {
        const newErrors = {};
        if (!fullName) newErrors.fullName = t('subscribe.errors.fullNameRequired');
        if (!email) {
            newErrors.email = t('subscribe.errors.emailRequired');
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = t('subscribe.errors.emailInvalid');
        }
        return newErrors;
    };

    const handelSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            setFullName('');
            setEmail('');
            setErrors({});
        }
    };

    return (
        <section className="wpo-subscribe-section section-padding">
            <div className="s-shape">
                <img src={Shape} alt="" />
            </div>
            <div className="container">
                <SectionTitle subtitle={t('subscribe.subtitle')} title={t('subscribe.title')} />

                <div className="wpo-subscribe-wrap">
                    <form onSubmit={handelSubmit}>
                        <div className="form-field">
                            <input className="form-control"
                                type="text"
                                placeholder={t('subscribe.fullName')}
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)} />
                            {errors.fullName && <p className="error">{errors.fullName}</p>}
                        </div>
                        <div className="form-field">
                            <input
                                className="form-control"
                                type="email"
                                placeholder={t('subscribe.email')}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            {errors.email && <p className="error">{errors.email}</p>}
                        </div>
                        <div className="form-field s-btn">
                            <button className="theme-btn-s2" type="submit">{t('subscribe.button')} <i><img src={Shape1} alt="" /></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default SubscribeSection;
